import React from 'react';

interface ImageProps {
    asset: string;
    alt?: string;
    className?: string | undefined;
    onClick?: () => void
}

const Image: React.FC<ImageProps> = ({asset, alt, className, onClick}) => {
    return (<img src={asset} alt={alt ?? ""} className={className ?? ""} loading={"lazy"} onClick={onClick}/>);
}

export default Image;